export function getCreateIdwellToIdwellRequestPayloadInitialValues(payload) {
  return (
    payload?.formProps?.initialValues ?? payload?.wizardProps?.initialValues
  )
}

export function getCreateIdwellToIdwellRequestSubmitPayload(
  payload,
  initialValues
) {
  return {
    ...payload,
    formProps: { ...payload?.formProps, initialValues },
    wizardProps: { ...payload?.wizardProps, initialValues },
  }
}
